import React, { useEffect, useState } from 'react';
import {
  getJobTitles,
  getAllCompanies,
  getAllRecruitersByCompanyID,
  addCompany,
  addRecruiter,
  addJobTitle,
  updateJobGroup,
  updateJobDescriptionDoc,
  deleteRound,
  getAllPlacementSpoc,
} from '../../../../services/apiService';
import { Dropdown, Modal, Icon, Accordion } from 'semantic-ui-react';
import RichTextEditor from './RichTextEditor.jsx';
import { Delete as DeleteIcon } from '@material-ui/icons';
import { getFullName } from '../../../../utils';

const roundTypeOptions = [
  {
    key: 'Interview',
    text: 'interview',
    value: 'interview',
  },
  {
    key: 'assignment',
    text: 'assignment',
    value: 'assignment',
  },
];

export const UpdateJobRoleInfo = ({
  jobGroupDetails,
  toggleUpdateRoleInfo,
  fetchJobApplicationsForJobGroup,
  getJobDetailsById,
}) => {
  // Rounds state and setter
  const [activeIndex, setActiveIndex] = useState(0);
  const [jobDescriptionDocument, setJobDescriptionDocument] = useState(null);
  const [companyImageFile, setCompanyImageFile] = useState(null);
  const [recruiterImageFile, setRecruiterImageFile] = useState(null);
  const [newCompany, setNewCompany] = useState('');
  const [newRecruiter, setNewRecruiter] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
  });
  // const [newJobTitle, setNewJobTitle] = useState('');
  const [jobTitles, setJobTitles] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [recruiters, setRecruiters] = useState([]);
  const [showCompanyModal, setShowCompanyModal] = useState(false);
  const [showRecruiterModal, setShowRecruiterModal] = useState(false);
  const [rounds, setRounds] = useState(
    jobGroupDetails?.allRoundDetails || [
      {
        number: 1,
        description: '',
        roundType: 'interview',
      },
    ]
  );
  const [loading, setLoading] = useState(false);
  const [basicDetails, setBasicDetails] = useState({
    jobTitleId: '',
    jobTitle: '',
    companyId: null,
    companyName: '',
    companyAvatar: '',
    description: '',
  });
  const [recruiterDetails, setRecruiterDetails] = useState({
    recruiterId: '',
    name: '',
    email: '',
    phone: '',
  });
  const [allPlacementSpoc, setAllPlacementSpoc] = useState([]);
  const [placementSpocId, setPlacementSpocId] = useState(
    jobGroupDetails?.placementSpocId ?? ''
  );

  // handler for the rounds accordian
  const handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const newIndex = activeIndex === index ? -1 : index;

    setActiveIndex(newIndex);
  };

  const addNewRound = () => {
    const newRound = {
      number: rounds.length + 1,
      description: '',
      roundType: 'interview',
    };
    setRounds([...rounds, newRound]);
  };

  // add a new jobTtile
  const addNewJobTitle = async (newTitle) => {
    try {
      setLoading(true);
      const response = await addJobTitle({ title: newTitle });
      setLoading(false);
      setJobTitles([...jobTitles, response?.data]);
      setBasicDetails({
        ...basicDetails,
        jobTitleId: response?.data?.jobTitleId,
      });
      // setNewJobTitle('');
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  // add a new company
  const addNewCompany = React.useCallback(async () => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append('companyName', newCompany);
      formData.append('file', companyImageFile);
      const response = await addCompany(formData);
      setLoading(false);
      setNewCompany('');
      setCompanyImageFile(null);
      setCompanies([...companies, response?.data]);
      setBasicDetails({
        ...basicDetails,
        companyId: response?.data?.companyId,
      });
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  }, [newCompany, companyImageFile, companies]);

  // add a new recruiter
  const addNewRecruiter = React.useCallback(async () => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append('companyId', basicDetails.companyId);
      formData.append('file', recruiterImageFile);
      formData.append('name', newRecruiter.name);
      formData.append('email', newRecruiter.email);
      formData.append('phone', newRecruiter.phone);
      const response = await addRecruiter(formData);
      setLoading(false);
      setNewRecruiter({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
      });
      setRecruiterImageFile(null);
      setRecruiters([...recruiters, response?.data]);
      setRecruiterDetails({
        ...recruiterDetails,
        recruiterId: response?.data?.recruiterId,
      });
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  }, [newRecruiter, recruiterImageFile, recruiters]);

  // delete a round
  const deleteRoundHandler = async (roundNumber) => {
    if (
      jobGroupDetails?.allRoundDetails?.filter(
        (item) => item.number === roundNumber
      )?.length === 0
    ) {
      const updatedRounds = [...rounds];
      updatedRounds.pop();
      return setRounds(updatedRounds);
    }
    try {
      const response = await deleteRound({
        groupId: jobGroupDetails?.groupId,
        roundNumber,
      });
      console.log('round deleted', response);
      fetchJobApplicationsForJobGroup(jobGroupDetails?.groupId);
      getJobDetailsById(jobGroupDetails?.groupId);
    } catch (error) {
      console.log(error);
    }
  };

  // fetch job titles and companies
  const fetchBasicDetailOptions = async () => {
    try {
      setLoading(true);
      const _jobTitles = await getJobTitles();
      const _companies = await getAllCompanies();
      setLoading(false);
      setJobTitles(_jobTitles?.data ?? []);
      setCompanies(_companies?.data ?? []);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  // fetch all placement SPOC
  const fetchAllPlacementSPOC = async () => {
    try {
      setLoading(true);
      const response = await getAllPlacementSpoc();
      const options = response?.data?.map(
        ({ placementSpocDetails, placementSpocId }) => ({
          key: placementSpocDetails.id,
          text: getFullName(placementSpocDetails),
          value: placementSpocId,
          image: {
            avatar: true,
            src: placementSpocDetails.thumbnail,
          },
        })
      );
      setAllPlacementSpoc(options);
    } catch (err) {
      setLoading(false);
      console.log('err fetching placement spoc', err);
    }
  };

  // fetch recruiters by company id
  const fetchRecruiterDetailOptions = async () => {
    try {
      setLoading(true);
      const _recruiters = await getAllRecruitersByCompanyID(
        basicDetails.companyId
      );
      setLoading(false);
      setRecruiters(_recruiters?.data ?? []);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const updateJDDoc = async (groupId) => {
    try {
      const formData = new FormData();
      formData.append('groupId', groupId);
      formData.append('file', jobDescriptionDocument);
      await updateJobDescriptionDoc(formData);
    } catch (error) {
      console.log(error);
    }
  };

  // update job group details
  const updateJobGroupDetails = async () => {
    try {
      setLoading(true);
      const apiData = {
        groupId: jobGroupDetails?.groupId,
        jobDescription: basicDetails.description,
        jobTitleId: basicDetails?.jobTitleId ?? null,
        companyId: basicDetails?.companyId ?? null,
        rounds: rounds,
        recruiterId: recruiterDetails?.recruiterId ?? null,
      };
      if (placementSpocId !== jobGroupDetails?.placementSpocId) {
        apiData.placementSpocId = placementSpocId;
      }
      await updateJobGroup(apiData);
      if (jobDescriptionDocument) {
        updateJDDoc(jobGroupDetails?.groupId);
      }
      setLoading(false);
      fetchJobApplicationsForJobGroup(jobGroupDetails?.groupId);
      getJobDetailsById(jobGroupDetails?.groupId);
      toggleUpdateRoleInfo();
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  // fetch job titles and placement spoc on component mount
  useEffect(() => {
    fetchBasicDetailOptions();
    fetchAllPlacementSPOC();
  }, []);

  // fetch recruiters on company change
  useEffect(() => {
    if (basicDetails.companyId) {
      fetchRecruiterDetailOptions();
    }
  }, [basicDetails.companyId]);

  // set basic details and recruiter details on jobGroupDetails change
  useEffect(() => {
    if (jobGroupDetails) {
      setBasicDetails({
        jobTitleId: jobGroupDetails?.jobTitleId,
        companyId: jobGroupDetails?.companyId,
        description: jobGroupDetails?.jobDescription,
      });
      setRecruiterDetails({
        recruiterId: jobGroupDetails?.recruiterId,
      });
      setRounds(jobGroupDetails?.allRoundDetails);
      setJobDescriptionDocument(jobGroupDetails?.jobDescriptionDoc);
    }
  }, [jobGroupDetails]);

  const handleAddNewCompany = (companyName) => {
    setShowCompanyModal(true);
    setNewCompany(companyName);
  };

  // console.log({ rounds, jobGroupDetails });

  const renderUpdateJobRoleInfoScreen = () => {
    return (
      <form className='w-full px-10 py-10 bg-white'>
        <div className='flex-col items-center justify-between'>
          <h1 className='mt-5 text-3xl font-semibold user-heading'>
            <Icon
              name='arrow left'
              className='pr-8 cursor-pointer '
              onClick={() => {
                toggleUpdateRoleInfo(false);
              }}
            />
            Update Job Role Info
          </h1>
        </div>
        <h2 className='mt-3 text-lg font-semibold user-heading'>
          Basic Details
        </h2>
        <hr className='mb-4 border-6 ' />
        <div className='flex flex-wrap mb-6 -mx-3'>
          <div className='w-full px-3 mb-6 md:w-1/2 md:mb-0'>
            <label
              className='block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase'
              htmlFor='grid-state'
            >
              Job Title
            </label>
            <Dropdown
              options={jobTitles.map((jobTitle) => ({
                key: jobTitle.jobTitleId,
                text: jobTitle.title,
                value: jobTitle.jobTitleId,
              }))}
              onChange={(e, { value, text }) => {
                // find the job title by id from the list of job titles
                const _jobTitle = jobTitles.find(
                  (job) => job.jobTitleId === value
                );
                setBasicDetails({
                  ...basicDetails,
                  jobTitleId: value,
                  jobTitle: _jobTitle?.title ?? '',
                });
              }}
              placeholder='Choose a job title or create a new one'
              search
              selection
              fluid
              allowAdditions
              value={basicDetails.jobTitleId || ''}
              onAddItem={(e, { value }) => {
                addNewJobTitle(value);
              }}
            />
          </div>
          <div className='w-full px-3 md:w-1/2'>
            <label
              className='block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase'
              htmlFor='grid-state'
            >
              Company Name
            </label>
            <Dropdown
              options={companies.map((company) => ({
                key: company.companyId,
                text: company.companyName,
                value: company.companyId,
                image: { avatar: true, src: company.companyAvatar },
              }))}
              onChange={(e, { value, text }) => {
                // find the company details from the companies array
                const _company = companies.find(
                  (company) => company.companyId === value
                );
                setBasicDetails({
                  ...basicDetails,
                  companyId: value,
                  companyName: _company?.companyName ?? '',
                  companyAvatar: _company?.companyAvatar ?? '',
                });

                // reset recruiter details
                setRecruiterDetails({
                  ...recruiterDetails,
                  recruiterId: '',
                  name: '',
                  email: '',
                  phone: '',
                });
              }}
              placeholder='Choose a company or create a new one'
              search
              selection
              fluid
              allowAdditions
              value={basicDetails.companyId || ''}
              onAddItem={(e, { value }) => {
                handleAddNewCompany(value);
              }}
            />
          </div>
        </div>

        <div className='flex flex-wrap mb-6 -mx-3'>
          <div className='w-full px-3 mb-6 md:w-1/2 md:mb-0'>
            <label
              className='block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase'
              htmlFor='grid-state'
            >
              Recruiter Name
            </label>
            <Dropdown
              options={recruiters.map((recruiter) => ({
                key: recruiter.recruiterId,
                text: recruiter.name,
                value: recruiter.recruiterId,
                image: { avatar: true, src: recruiter.avatar },
              }))}
              onChange={(e, { value, text, email, phone }) => {
                // find the recruiter in the list of recruiters
                const _recruiter = recruiters.find(
                  (recruiter) => recruiter.recruiterId === value
                );
                setRecruiterDetails({
                  ...recruiterDetails,
                  recruiterId: value,
                  name: _recruiter?.name ?? '',
                  email: _recruiter?.email ?? '',
                  phone: _recruiter?.phone ?? '',
                });
              }}
              placeholder='Recruiter Name'
              search
              disabled={!basicDetails.companyId}
              selection
              fluid
              allowAdditions
              value={recruiterDetails.recruiterId || ''}
              onAddItem={(e, { value }) => {
                setNewRecruiter({ ...newRecruiter, name: value });
                setShowRecruiterModal(true);
              }}
            />
          </div>
          <div className='w-full px-3 md:w-1/2'>
            <label
              className='block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase'
              htmlFor='grid-state'
            >
              Placement SPOC
            </label>
            <Dropdown
              options={allPlacementSpoc}
              onChange={(e, { value }) => {
                setPlacementSpocId(value);
              }}
              placeholder='Placement Spoc'
              search
              selection
              fluid
              value={placementSpocId || ''}
            />
          </div>
        </div>

        {/* <div className='flex flex-wrap mb-2 -mx-3'>
          <div className='w-full px-3 mb-6 md:w-1/3 md:mb-0'>
            <label
              className='block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase'
              htmlFor='grid-city'
            >
              Recruiter Name
            </label>

            <Dropdown
              options={recruiters.map((recruiter) => ({
                key: recruiter.recruiterId,
                text: recruiter.name,
                value: recruiter.recruiterId,
                image: { avatar: true, src: recruiter.avatar },
              }))}
              onChange={(e, { value, text, email, phone }) => {
                // find the recruiter in the list of recruiters
                const _recruiter = recruiters.find(
                  (recruiter) => recruiter.recruiterId === value
                );
                setRecruiterDetails({
                  ...recruiterDetails,
                  recruiterId: value,
                  name: _recruiter?.name ?? '',
                  email: _recruiter?.email ?? '',
                  phone: _recruiter?.phone ?? '',
                });
              }}
              placeholder='Recruiter Name'
              search
              disabled={!basicDetails.companyId}
              selection
              fluid
              allowAdditions
              value={recruiterDetails.recruiterId || ''}
              onAddItem={(e, { value }) => {
                setNewRecruiter({ ...newRecruiter, name: value });
                setShowRecruiterModal(true);
              }}
            />
          </div>
        </div> */}
        <h2 className='mt-5 text-lg font-semibold user-heading'>
          Interview Rounds
        </h2>
        <hr className='mb-5 border-6 ' />
        <Accordion>
          {rounds.map(
            (round, index) =>
              round && (
                <>
                  <Accordion.Title
                    active={activeIndex === index}
                    index={index}
                    onClick={handleClick}
                  >
                    <div
                      className='flex flex-row items-center justify-between'
                      style={{ width: 'fit-content' }}
                    >
                      <div className='col-span-1'>
                        <Icon
                          size='large'
                          name='plus square outline'
                          color='red'
                        />
                      </div>
                      <div className='col-span-1 mr-10 font-semibold text-brand-primary '>
                        {`Round ${round?.number}`}
                      </div>

                      {index === rounds.length - 1 && (
                        <div className='col-span-1 ml-15'>
                          <DeleteIcon
                            className='text-brand-primary'
                            onClick={(e) => {
                              e.stopPropagation();
                              // deleteRound(index);
                              deleteRoundHandler(round?.number);
                            }}
                          />
                        </div>
                      )}
                    </div>
                  </Accordion.Title>
                  <Accordion.Content active={activeIndex === index}>
                    <div className='flex-col'>
                      <div className='w-1/4 px-4 py-3 leading-tight text-gray-700 border border-gray-200 rounded focus:outline-none focus:bg-white focus:border-gray-500 my-25 '>
                        <Dropdown
                          fluid
                          options={roundTypeOptions}
                          placeholder='Round Type'
                          onChange={(e, { value }) => {
                            const _rounds = [...rounds];
                            _rounds[index].roundType = value;
                            setRounds(_rounds);
                          }}
                          value={round?.roundType ?? 'interview'}
                        />
                      </div>

                      <div
                        className='mt-5 overflow-auto max-h-96'
                        style={{ width: '100%' }}
                      >
                        <input
                          type='text'
                          className='block w-full px-4 py-3 leading-tight text-gray-700 border border-gray-200 rounded focus:outline-none focus:bg-white focus:border-gray-500'
                          value={round.description}
                          placeholder='Round Description'
                          onChange={(e) => {
                            const _rounds = [...rounds];
                            _rounds[index].description = e.target.value;
                            setRounds(_rounds);
                          }}
                        />
                      </div>
                    </div>
                  </Accordion.Content>
                </>
              )
          )}
        </Accordion>
        <div
          onClick={() => {
            addNewRound();
          }}
          className='px-8 py-2 mt-5 ml-5 text-base font-medium rounded cursor-pointer bg-pastel-red text-brand-primary w-60'
        >
          <Icon name='add' />
          <span> Add Round </span>
        </div>

        <h2 className='mt-5 text-lg font-semibold user-heading'>
          Job Description
        </h2>
        <hr className='mb-5 border-6 ' />
        <div className='flex flex-wrap mb-6 -mx-3'>
          {/* <div className='flex-wrap flex-1 mb-6 -mx-3'> */}
          <div className='w-2/3 px-3' style={{ flex: 0.5 }}>
            <label
              className='block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase'
              htmlFor='grid-password'
            >
              Job Description
            </label>
            <div className='w-full'>
              <RichTextEditor
                initialValue={basicDetails.description}
                getValue={(value) => {
                  setBasicDetails({
                    ...basicDetails,
                    description: value,
                  });
                }}
              />
            </div>
          </div>
          <div className='w-1/3 px-3' style={{ flex: 0.5 }}>
            <label
              htmlFor='pdf'
              type='button'
              className='flex items-end justify-end w-full h-full '
            >
              <div
                className='flex flex-col items-center justify-center w-full border-2 border-dashed h-80 '
                onDragOver={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
                onDragLeave={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
                onDrop={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  const file = e.dataTransfer.files[0];
                  setJobDescriptionDocument(file);
                }}
              >
                <div className='flex flex-col items-center justify-center'>
                  <div className='mb-10 text-2xl'>Upload JD Document</div>
                  <div className='flex items-center justify-center'>
                    <i className='text-5xl fas fa-file-pdf text-brand-primary' />
                  </div>
                  {jobDescriptionDocument && (
                    <div className='mt-5 text-sm'>
                      {jobDescriptionDocument.name} Doc uploaded
                      <i
                        className='ml-2 text-gray-400 fas fa-times'
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          setJobDescriptionDocument(null);
                        }}
                      />
                      <a
                        href={`${jobDescriptionDocument}`}
                        target='_blank'
                        rel='noreferrer'
                      >
                        <i className='ml-2 text-gray-400 fas fa-eye' />
                      </a>
                    </div>
                  )}
                  {!jobDescriptionDocument && (
                    <p className='text-sm text-gray-400'>
                      <span className='font-medium text-gray-600'>
                        Drag and drop your file here
                      </span>
                    </p>
                  )}
                  <p className='mt-1 text-xs text-gray-400'>
                    Supported file type : PDF
                  </p>

                  <div
                    type='button'
                    className='p-2 mt-2 text-black bg-gray-300'
                  >
                    Choose File
                  </div>
                </div>
              </div>
            </label>
            <input
              type='file'
              id='pdf'
              style={{ visibility: 'hidden', width: '0px' }}
              onChange={(e) => {
                setJobDescriptionDocument(e.target.files[0]);
              }}
            />
            {/* </div> */}
          </div>
        </div>
        <div className='flex flex-wrap justify-center mb-2 -mx-3 mt-30'>
          <button
            onClick={() => {
              toggleUpdateRoleInfo();
            }}
            className='px-8 py-2 ml-8 text-base font-medium border rounded text-gray border-primary-400'
          >
            Cancel
          </button>
          <button
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              updateJobGroupDetails();
            }}
            disabled={
              loading ||
              !basicDetails.companyId ||
              !basicDetails.jobTitleId ||
              !recruiterDetails.recruiterId
            }
            className={`${
              !basicDetails.companyId ||
              !basicDetails.jobTitleId ||
              !recruiterDetails.recruiterId
                ? 'bg-red-500 cursor-not-allowed'
                : 'bg-brand-primary'
            } text-base font-medium text-white border border-primary-400 px-8 py-2 ml-8 rounded`}
          >
            Save Details
          </button>
        </div>

        {/* Start Of Create Company Modal */}
        <Modal
          onClose={() => setShowCompanyModal(false)}
          onOpen={() => setShowCompanyModal(true)}
          open={showCompanyModal}
        >
          <Modal.Header>Add a new company</Modal.Header>
          <Modal.Content>
            <Modal.Description>
              <div className='flex flex-wrap justify-start mb-2'>
                <div className='relative flex'>
                  <label
                    htmlFor='file'
                    type='button'
                    className='w-20 h-20 border-2 rounded-full cursor-pointer bg-red-50 ring-gray-900 ring-1'
                    style={{
                      backgroundImage: `url(${
                        companyImageFile
                          ? URL.createObjectURL(companyImageFile)
                          : ''
                      })`,
                      backgroundSize: 'cover',
                      backgroundRepeat: 'no-repeat',
                      backgroundPosition: 'center center',
                    }}
                  />
                  <Icon
                    name='pencil alternate'
                    style={{
                      position: 'absolute',
                      bottom: '15px',
                      right: '10px',
                    }}
                  />
                  <input
                    type='file'
                    id='file'
                    style={{ visibility: 'hidden', width: '0px' }}
                    onChange={(e) => {
                      setCompanyImageFile(e.target.files[0]);
                    }}
                  />
                </div>
                <div className='w-full px-3 mb-6 flex-2 md:w-1/3 md:mb-0'>
                  <label
                    className='block mb-2 text-xs font-bold tracking-wide text-gray-700'
                    htmlFor='grid-zip'
                  >
                    Company Name
                  </label>
                  <input
                    className='block w-full px-4 py-3 leading-tight text-gray-700 bg-gray-200 border border-gray-200 rounded appearance-none focus:outline-none focus:bg-white focus:border-gray-500'
                    id='grid-zip'
                    type='text'
                    value={newCompany}
                    onChange={(e) => {
                      setNewCompany(e.target.value);
                    }}
                    placeholder='Type in the name of the company'
                  />
                </div>
              </div>
            </Modal.Description>
          </Modal.Content>
          <Modal.Actions>
            <button
              onClick={() => {
                setShowCompanyModal(false);
              }}
              className='px-8 py-2 ml-8 text-base font-medium border rounded text-gray border-primary-400'
            >
              Cancel
            </button>
            <button
              onClick={() => {
                setShowCompanyModal(false);
                addNewCompany();
              }}
              className='px-8 py-2 ml-8 text-base font-medium text-white border rounded bg-brand-primary border-primary-400'
            >
              Add Company
            </button>
          </Modal.Actions>
        </Modal>

        {/* End Of Create Company Modal */}
        {/* Start Of Add Recruiter Modal */}
        <Modal
          onClose={() => setShowRecruiterModal(false)}
          onOpen={() => setShowRecruiterModal(true)}
          open={showRecruiterModal}
        >
          <Modal.Header>Add a new Recruiter</Modal.Header>
          <Modal.Content>
            <Modal.Description>
              <div className='flex flex-wrap justify-start mb-2'>
                <div className='relative flex'>
                  <label
                    htmlFor='file'
                    type='button'
                    className='w-20 h-20 border-2 rounded-full cursor-pointer bg-red-50 ring-gray-900 ring-1'
                    style={{
                      backgroundImage: `url(${
                        recruiterImageFile
                          ? URL.createObjectURL(recruiterImageFile)
                          : ''
                      })`,
                      backgroundSize: 'cover',
                      backgroundRepeat: 'no-repeat',
                      backgroundPosition: 'center center',
                    }}
                  />
                  <Icon
                    name='pencil alternate'
                    style={{
                      position: 'absolute',
                      bottom: '15px',
                      right: '10px',
                    }}
                  />
                  <input
                    type='file'
                    id='file'
                    style={{ visibility: 'hidden', width: '0px' }}
                    onChange={(e) => {
                      setRecruiterImageFile(e.target.files[0]);
                    }}
                  />
                </div>
                <div className='w-full px-3 mb-6 flex-2 md:w-1/3 md:mb-0'>
                  <label
                    className='block mb-2 text-xs font-bold tracking-wide text-gray-700'
                    htmlFor='grid-zip'
                  >
                    Recruiter Name
                  </label>
                  <input
                    className='block w-full px-4 py-3 leading-tight text-gray-700 bg-gray-200 border border-gray-200 rounded appearance-none focus:outline-none focus:bg-white focus:border-gray-500'
                    id='grid-zip'
                    type='text'
                    value={newRecruiter.name}
                    onChange={(e) => {
                      setNewRecruiter({
                        ...newRecruiter,
                        name: e.target.value,
                      });
                    }}
                    placeholder='Type in the name of the Recruiter'
                  />
                </div>
                <div className='w-full px-3 mb-6 flex-2 md:w-1/3 md:mb-0'>
                  <label
                    className='block mb-2 text-xs font-bold tracking-wide text-gray-700'
                    htmlFor='grid-zip'
                  >
                    Email
                  </label>
                  <input
                    className='block w-full px-4 py-3 leading-tight text-gray-700 bg-gray-200 border border-gray-200 rounded appearance-none focus:outline-none focus:bg-white focus:border-gray-500'
                    id='grid-zip'
                    type='text'
                    value={newRecruiter.email}
                    onChange={(e) => {
                      setNewRecruiter({
                        ...newRecruiter,
                        email: e.target.value,
                      });
                    }}
                    placeholder='Enter email address'
                  />
                </div>
                <div className='w-full px-3 mt-6 mb-6 flex-2 md:w-1/3 md:mb-0'>
                  <label
                    className='block mb-2 text-xs font-bold tracking-wide text-gray-700'
                    htmlFor='grid-zip'
                  >
                    Mobile Number
                  </label>
                  <input
                    className='block w-full px-4 py-3 leading-tight text-gray-700 bg-gray-200 border border-gray-200 rounded appearance-none focus:outline-none focus:bg-white focus:border-gray-500'
                    id='grid-zip'
                    type='number'
                    value={newRecruiter.phone}
                    onChange={(e) => {
                      setNewRecruiter({
                        ...newRecruiter,
                        phone: e.target.value,
                      });
                    }}
                    placeholder='Enter mobile number'
                  />
                </div>
              </div>
            </Modal.Description>
          </Modal.Content>
          <Modal.Actions>
            <button
              onClick={() => {
                setShowRecruiterModal(false);
              }}
              className='px-8 py-2 ml-8 text-base font-medium border rounded text-gray border-primary-400'
            >
              Cancel
            </button>
            <button
              onClick={() => {
                setShowRecruiterModal(false);
                addNewRecruiter();
              }}
              className='px-8 py-2 ml-8 text-base font-medium text-white border rounded bg-brand-primary border-primary-400'
            >
              Save Recruiter
            </button>
          </Modal.Actions>
        </Modal>
        {/* End Of Add Recruiter Modal */}
      </form>
    );
  };

  return <div>{renderUpdateJobRoleInfoScreen()} </div>;
};
